<template>
  <div class="main">
    <span>
      <div v-if="!readOnly" class="op">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
        <div v-if="equipments.length">
          <b-card>
            <div v-for="(prop, index) in equipments" :key="prop.caption + index">
              <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOff($event, prop)"
                  switch
                  >
                  {{ prop.equipName }}
            </b-form-checkbox>
            </div>
          </b-card>
        </div>
        <b-card v-else>
            <label class="eqMsgTxt">{{ $t('operacao-sem-equipamentos') }}</label>
          </b-card>
        <div class="ml-3 attr-list">
          <b-card>
            <div class="inp" v-if="option.value == 1">
                <label>{{ $t('brix-0') }}</label>
                <b-input class="inputAttrValue" v-model="brix.value" type="number"></b-input>
            </div>
            <div class="inp" v-if="option.value == 4 && brixSaida">
                <label>{{ $t('brix-saida') }}</label>
              <label>{{ brixSaida.value | ParseNumber }}</label>
            </div>
            <div v-if="brix && option.value != 1 && brixSaida == 0" class="inp">
              <label>{{ $t('brix-1') }}</label>
              <label>{{ brix.value | ParseNumber }}</label>
            </div>
            <div v-if="AreaTotal && AreaTotal.value != -9999" class="inp">
              <label>{{ $t('area-total-m') }} </label>
              <label>{{ AreaTotal.value | ParseNumber }}</label>
            </div>
            <div v-if="TaxaOcupacao && AreaTotal.value != -9999" class="inp">
              <label>{{ $t('ocupacao-1') }} </label>
              <label>{{ TaxaOcupacao.value | ParseNumber }}</label>
            </div>
            <div class="inp mb-1" v-if="option.value == 4 && AreaTotal.value != -9999">
                <label>{{ $t('taxa-ideal-kg-h-m') }}</label>
                <b-input class="inputAttrValue" v-model="TaxaEvap.value" type="number"></b-input>
              </div>
            <div v-if="TaxaEvap && option.value != 4 && AreaTotal.value != -9999" class="inp">
              <label>{{ $t('taxa-ideal-kg-h-m-0') }}</label>
              <label>{{ TaxaEvap.value | ParseNumber }}</label>
            </div>
            <div v-if="TaxaEvapReal && AreaTotal.value != -9999" class="inp">
              <label>{{ $t('taxa-real-kg-h-m-0') }}</label>
              <label>{{ TaxaEvapReal.value | ParseNumber }}</label>
            </div>
          </b-card>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2 ml-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                    class="switch-item"
                    v-model="prop.value"
                    @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                    switch
                    >
                    {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div v-if="joker.capacidade" class="inp mb-2">
                  <label>{{ $t('area-total-m-0') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div v-if="joker.Ocupacao" class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { NumberFormat, ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin';
import TextToInput from "../../../template/TextToInput";
import { FiltersMixin } from "../../../mixins/filtersMixin";


export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },
  
  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  data() {
    return {
      attrList: ["option", "brix", "AreaTotal", "TaxaOcupacao", "TaxaEvap", "TaxaEvapReal", "brixSaida"],
      w: 0,
      verifyBrix: 0,
      verifyIdeal: 0,
      propVap: {},
      option: {},
      brix: {},
      brixSaida: {},
      AreaTotal: {},
      TaxaOcupacao: {},
      TaxaEvap: {},
      TaxaEvapReal: {},
      operationSelected: null,
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
      showAmountOfSteam: false,
      currents: [{ value: null, text:this.$t('selecione-uma-corrente') }],
      current: null,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));


      this.attrList.forEach((attrName) => {
        let prop = this.operationAttributeList.find(p => attrName == p.key)
      
        if (prop) {
          this[attrName] = prop
          this[attrName].value = ParseToNumber(this[attrName].value);
        } 
      });
      
      this.updateNode();
      this.jokerEquipmentList = [];
    },

    
    "brix.value"() {
      this.updateNode();
    },

    "TaxaEvap.value"() {
      this.updateNode();
    },

    current(value) {
      if (value) this.node.currentVapProd = value;
    },

    w(value) {
      if(this.showAmountOfSteam){
        this.propVap.value = NumberFormat(value);
        this.updateNode();
      }
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;

        if (this.node.currentVapProd) {
          this.current = this.node.currentVapProd;
          this.changeCurrent();
        }

        this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
        this.loadNotInput();
      }
      this.equipments = new Array();

      this.showAmountOfSteam = this.node.showAmountOfSteam;

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }

        if (p.index == this.node.currentVapProd) {
          this.w = ParseToNumber(p.value);
          this.propVap = p;
        }

        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
      this.ChangeCapacidade();
    },

    updateNode() {
      this.ChangeCapacidade();
      if(this.firstLoad) return
      let attrs = []
      if(this.brixSaida && this.brixSaida.value){   
        attrs = [this.option.clone(), this.brix.clone(), this.AreaTotal.clone(), this.TaxaOcupacao.clone(), this.brixSaida.clone()];
      }else{
        attrs = [this.option.clone(), this.brix.clone(), this.AreaTotal.clone(), this.TaxaOcupacao.clone()];
      }
      
      if (this.TaxaEvap && this.TaxaEvap.value) {
        attrs.push(this.TaxaEvap);
      }

      if (this.TaxaEvapReal && this.TaxaEvapReal.value) {
        attrs.push(this.TaxaEvapReal);
      }

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });

      setTimeout(()=>{
        this.node.showAmountOfSteam = this.showAmountOfSteam;
        }, 100)

      if(this.showAmountOfSteam)
        attrs.push(this.propVap);

      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    ChangeCapacidade() {
      if (this.equipments.length > 0) {
        if (this.AreaTotal) {
          this.AreaTotal.value = 0;
          this.equipments.forEach((e) => {
            let cap = this.equipCap.find((c) => c.equipName == e.equipName);
            if (e.value && cap) {
              this.AreaTotal.value += parseFloat(
                String(cap.value).replace(",", ".")
              );
            }
          });
        }
      } else {
        this.AreaTotal.value = -9999;
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Evaporador\|EV_/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    loadCurrents() {
      let crList = SingletonEnginnering.currents;
      this.currents.splice(1);
      crList.forEach((cr) => this.currents.push({ value: cr, text: cr }));
    },

    changeCurrent() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.current);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.current,
        attrs[0]
      );

      props.forEach((p) => {
        if (p.key == "W") {
          this.w = ParseToNumber(p.value);
          this.propVap = p;
        }
      });
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.loadCurrents();
    this.changeExternalCapacity = function () { this.ChangeCapacidade() }
    this.updataNodeInMixin = function () { this.updateNode() }
  },
};
</script>

<style scoped>
.main{
  display: flex;
}

form {
  padding: 10px;
  color: #0009;
}

.form-control{
  width: 30%;
  height: 25px;
  text-align: right;
}

.check {
  margin: 2%;
}

.op {
  margin: 2%;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

.inputAttrValue{
  padding: 10px;
}

input {
  margin-left: 5px;
}

.inp {
  margin: 1px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.attr-list{
  min-width: 350px;
}
</style>